import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const problems = ['Facturás todos los meses pero nunca sabés cuánto ganás realmente.', 'Sentís que trabajás cada vez más y la plata nunca alcanza.', 'No sabés exactamente en qué se va el dinero de tu negocio.', 'Vivís apagando incendios financieros.', 'No tenés un sistema para organizar tus ingresos y gastos.', 'Querés crecer pero siempre te falta dinero para hacerlo.', 'Sentís que tu negocio depende completamente de vos.'];
export function ProblemSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-14 md:py-20 bg-surface relative" data-id="element-239">
      <div className="container mx-auto px-5 md:px-6" data-id="element-240">
        <div className="max-w-4xl mx-auto" data-id="element-241">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="text-center mb-8 md:mb-12" data-id="element-242">
            <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-6 text-balance" data-id="element-243">
              SI TE IDENTIFICÁS CON ALGUNO DE ESTOS PROBLEMAS,{' '}
              <span className="text-primary italic" data-id="element-244">
                ESTE MÉTODO ES PARA VOS
              </span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 md:gap-3 mb-10 md:mb-14" data-id="element-245">
            {problems.map((problem, index) => {
            const isActive = activeIndex === index;
            return <motion.button key={index} type="button" onClick={() => setActiveIndex(isActive ? null : index)} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} whileTap={{
              scale: 0.98
            }} viewport={{
              once: true,
              margin: '-30px'
            }} transition={{
              delay: Math.min(index * 0.06, 0.4)
            }} className={`flex items-start gap-3 p-3.5 md:p-4 rounded-2xl bg-background border text-left transition-all ${isActive ? 'border-primary/60 bg-primary/[0.04] shadow-[0_0_20px_-8px_rgba(16,185,129,0.3)]' : 'border-surface-light hover:border-primary/30'}`} data-id="element-246">
                  <div className={`mt-0.5 flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full flex items-center justify-center transition-colors ${isActive ? 'bg-primary/20' : 'bg-red-500/10'}`} data-id="element-247">
                    <XIcon className={`w-3.5 h-3.5 md:w-4 md:h-4 transition-colors ${isActive ? 'text-primary' : 'text-red-400'}`} data-id="element-248" />
                  </div>
                  <p className={`text-sm md:text-base leading-snug transition-colors ${isActive ? 'text-white' : 'text-text-muted'}`} data-id="element-249">
                    {problem}
                  </p>
                </motion.button>;
          })}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center p-5 md:p-10 rounded-2xl md:rounded-3xl bg-gradient-to-b from-surface-light to-background border border-surface-light relative overflow-hidden" data-id="element-250">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" data-id="element-251" />

            <p className="text-base md:text-2xl leading-relaxed text-balance" data-id="element-252">
              La realidad es que la mayoría de los emprendedores no tiene un
              problema de ventas.
              <strong className="text-white font-serif text-2xl md:text-4xl block my-3 md:my-4" data-id="element-253">
                Tiene un problema de organización financiera.
              </strong>
              Y eso es exactamente lo que vas a solucionar con{' '}
              <span className="text-primary font-semibold" data-id="element-254">
                Reinicia Tus Finanzas
              </span>
              .
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}